/**
 * Stale-build detection. The build stamps `__BUILD_ID__` into the bundle and
 * emits the same value at /version.json (never cached). When the served id
 * differs from the running one, a newer deploy is live and the tab should
 * reload before the operator records anything against old code.
 */
export const CURRENT_BUILD_ID: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

export function isNewBuildAvailable(running: string, served: unknown): boolean {
	if (typeof served !== 'string' || served.length === 0) return false;
	if (running === 'dev') return false; // vite dev server: no version.json, nothing to compare
	return served !== running;
}

export async function fetchServedBuildId(signal?: AbortSignal): Promise<string | null> {
	try {
		const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store', signal });
		if (!res.ok) return null;
		const body = (await res.json()) as { buildId?: unknown };
		return typeof body.buildId === 'string' ? body.buildId : null;
	} catch {
		return null; // offline or aborted: try again next tick
	}
}
